import { Card, Col, Row } from "react-bootstrap";
import { ParseDate } from "../../../../../Helpers/DateHelper";
import React from "react";

const FinishedApplicationsStatisticsList = ({ finishedApplications }) => {
  return finishedApplications?.map((finishedApplication, i) => (
    <Card
      key={i}
      className={"mt-4 list-container text-20 fw-medium text-color-gray-dark"}
      style={{ backgroundColor: "white" }}
    >
      <Row className={"list-row "} style={{ borderBottomWidth: 0 }}>
        <Col
          xs={3}
          className={"align-content-center text-color-gray-light"}
          style={{ borderRight: "2px solid #e7ecef" }}
        >
          <Row className={"justify-content-center"}>
            {ParseDate(finishedApplication.finishDate).date} {ParseDate(finishedApplication.finishDate).time}
          </Row>
        </Col>
        <Col className={"text-center"}>{finishedApplication.candidateName}</Col>
        <Col className={"text-center"}>{finishedApplication.applicationName}</Col>
      </Row>
    </Card>
  ));
};
export default FinishedApplicationsStatisticsList;
